import * as React from 'react';
import { withNodeResizable } from '../shared/NodeResizable';
import { Portal } from '../shared/Portal';
import { createEmbedExtension } from '../shared/createEmbedExtension';
import { EmbedRendererProps } from '../shared/types';

export const ENABLED = [
  /^https?:\/\/(www\.|app\.)?(lucidchart\.com|lucid\.app)\/documents\/(embeddedchart|view|edit)\/(?<chartId>[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})(?:.*)?$/,
  /^https?:\/\/(www\.|app\.)?(lucid\.app|lucidchart\.com)\/lucidchart\/(?<chartId>[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})\/(embeddedchart|view|edit)(?:.*)?$/,
];

export const Component = ({ url, ...rest }: EmbedRendererProps<any>) => {
  const chartId = React.useMemo(() => {
    const regexResults = ENABLED.find((regex) => regex.test(url));
    const matches = regexResults?.exec(url);
    return matches?.groups?.chartId || '';
  }, [url]);

  return (
    <Portal
      {...rest}
      url={`https://lucidchart.com/documents/embeddedchart/${chartId}`}
      title="Lucidchart Embed"
      fullHeight
      withMetadata
    />
  );
};

export default createEmbedExtension({
  regexp: ENABLED,
  name: 'lucidchart-embed',
  component: withNodeResizable(Component, {
    lockAspectRatio: true,
    defaultHeight: 500,
  }),
  addCommandOption: {
    title: 'Lucidchart',
    description: 'Embed a Lucidchart diagram.',
    searchTerms: ['embed', 'lucidchart'],
    icon: 'tabler:chart-bar',
  },
});
